export function numberToHumanSize(size: number) {
  if (size < 1000) {
    return `${size} bytes`;
  }
  if (size < 1000.0 * 1000.0) {
    return `${(size / 1000.0).toFixed(0)}KB`;
  }
  if (size < 1000.0 * 1000.0 * 1000.0) {
    return `${(size / 1000.0 / 1000.0).toFixed(0)}MB`;
  }
  return `${(size / 1000.0 / 1000.0 / 1024.0).toFixed(0)}GB`;
}
